<template>
  <div>
    Authenticating...
  </div>
</template>

<script>
export default {
  mounted() {
    // Get the authorization code from the URL query params
    const code = this.$route.query.code;
    console.log(code);
    // Now, make a request to Shopify's token endpoint to get the access token
    // You can use Axios or any other HTTP library to make the request.
    // The response will contain the access token which you can use to make authenticated API calls.

    // After getting the access token, you can store it in localStorage or Vuex store for later use.
  },
};
</script>



// WEBPACK FOOTER //
// src/views/ShopifyAuthCallback.vue